import React, { useEffect, useState } from "react";
import client from "../client/client";

import InputText from "../InputText/InputText";
import InputDate from "../InputDate/InputDate";
import InputCheckbox from "../InputCheckbox/InputCheckbox";
import PrewButton from "../PrewButton/PrewButton";
import NextButton from "../NextButton/NextButton";

function Step1(props) {
  const {
    setStep,
    name,
    setName,
    surname,
    setSurname,
    email,
    setEmail,
    phone,
    setPhone,
    telegram,
    setTelegram,
    dataAgreement,
    setDataAgreement,
  } = props;

  const [isFormFilled, setIsFormFilled] = useState(false);
  const [formErrors, setFormErrors] = useState(null);

  const submitHandler = (event) => {
    event.preventDefault();

    const url = `/first_step/`;

    const data = {
      name: name,
      f_name: surname,
      email: email,
      phone: phone,
      telegram: telegram,
      participation: dataAgreement,
    };

    client
      .post(url, data)
      .then((res) => {
        setStep(2);
      })
      .catch((error) => {
        if (error.response.status === 400) {
          if ("non_field_errors" in error.response.data) {
            setStep(5);
            return;
          }

          setFormErrors(error.response.data);
        }
      });
  };

  useEffect(() => {
    setIsFormFilled(name && surname && phone && email && dataAgreement && telegram);
  }, [name, surname, email, phone, dataAgreement, telegram]);

  useEffect(() => {
    if (formErrors) {
      const firstError = Object.keys(formErrors)[0];
      const firstErrorInput = document.querySelector(`[name=${firstError}]`);

      firstErrorInput.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  }, [formErrors]);

  return (
    <form action="." onSubmit={submitHandler}>
      <div className="mm-form__inner">
        <InputText
          title="Имя *"
          placeholder="Иван"
          value={name}
          onChange={setName}
          error={formErrors?.name}
          name="name"
        />
        <InputText
          title="Фамилия *"
          placeholder="Иванов"
          value={surname}
          onChange={setSurname}
          error={formErrors?.f_name}
          name="f_name"
        />
        <InputText
          title="E-mail *"
          placeholder="hello@yandex.ru"
          type="email"
          value={email}
          onChange={setEmail}
          error={formErrors?.email}
          name="email"
        />
        <InputDate
          title="Телефон *"
          placeholder="+7 999 000 00 00"
          mask="(+7) 999 999 9999"
          type="tel"
          value={phone}
          onChange={setPhone}
          error={formErrors?.phone}
          name="phone"
        />
        <InputText
          title="Телеграм *"
          placeholder="Telegram"
          value={telegram}
          onChange={setTelegram}
          error={formErrors?.telegram}
          name="telegram"
        />
        <InputCheckbox
          title="Согласен на <a href='https://create.travelhub.moscow/policy' target='_blank'>обработку персональных данных</a>"
          value={dataAgreement}
          onChange={setDataAgreement}
          name="participation"
        />
      </div>

      <div className="buttons-wrapper">
        <PrewButton isHidden={true} />
        <NextButton type="submit" disabled={!isFormFilled} />
      </div>
    </form>
  );
}

export default Step1;
